const serverRenderingUtils = require('anchor-website-common/helpers/serverRenderingUtils');

const APP_INIT = '@@index/APP_INIT';
const SESSION_NAME = 'anchorpw_s';
const ASSETS_PATH = 'https://d12xoj7p9moygp.cloudfront.net/';
const DEFAULT_PODCAST_IMAGE = `${ASSETS_PATH}images/default-podcast-image.png`;
const BUILD_ASSETS_PATH = 'https://d1rx8vrt2hn1hc.cloudfront.net/builds/';

// wrapped version of keymaster (not server-safe)
const assignKey = serverRenderingUtils.windowUndefined()
  ? function () {}
  : require('keymaster');

module.exports = {
  ...serverRenderingUtils,
  isIOS: serverRenderingUtils.isIOS,
  APP_INIT,
  appStoreLink,
  assignKey,
  doHideGetAppButton,
  ASSETS_PATH,
  BUILD_ASSETS_PATH,
  DEFAULT_PODCAST_IMAGE,
  getBaseUrl,
  getBlobUrlCreator,
  getDateWithoutHours,
  getEpisodeImage,
  getPodcastImage,
  isEmbedPath,
  isRWFPath,
  isPodcastDashboardPath,
  SESSION_NAME,
  playStoreLink,
  PODCAST_EPISODE_AUDIO_TYPES: {
    MOBILE_RECORDING: 'mobileRecording',
    // may be difficult to track in database (3.0 easier, or we add a special 'origin' for these files)
    UPLOAD: 'upload',
    INTERVIEW: 'interview',
    CALL_IN: 'callIn',
    INTERLUDE: 'interlude',
    LIBRARY: 'library',
  },
  PODCAST_IMPORT_ORIGIN: 'podcasts:import',
  PODCAST_IMPORT_STATUS: {
    FAILED: 'failed',
    IN_PROGRESS: 'inProgress',
    FINISHED: 'finished',
  },
  PROCESSOR_AUTH_OUTCOMES: {
    USER_HAS_NO_EMAIL: 'noEmail',
    STATION_HAS_MUSIC_IN_EPISODES: 'musicInEpisodes',
    STATION_HAS_IMPORTED_AND_NOT_REDIRECTED: 'notRedirected',
  },
  PODCAST_CATEGORIES: [
    {
      title: 'Arts',
      children: [
        'Design',
        'Fashion & Beauty',
        'Food',
        'Literature',
        'Performing Arts',
        'Visual Arts',
      ],
    },
    {
      title: 'Business',
      children: [
        'Business News',
        'Careers',
        'Investing',
        'Management & Marketing',
        'Shopping',
      ],
    },
    {
      title: 'Comedy',
      children: [],
    },
    {
      title: 'Education',
      children: [
        'Educational Technology',
        'Higher Education',
        'K-12',
        'Language Courses',
        'Training',
      ],
    },
    {
      title: 'Games & Hobbies',
      children: [
        'Automotive',
        'Aviation',
        'Hobbies',
        'Other Games',
        'Video Games',
      ],
    },
    {
      title: 'Government & Organizations',
      children: ['Local', 'National', 'Non-Profit', 'Regional'],
    },
    {
      title: 'Health',
      children: [
        'Alternative Health',
        'Fitness & Nutrition',
        'Self-Help',
        'Sexuality',
      ],
    },
    {
      title: 'Kids & Family',
      children: [],
    },
    {
      title: 'Music',
      children: [],
    },
    {
      title: 'News & Politics',
      children: [],
    },
    {
      title: 'Religion & Spirituality',
      children: [
        'Buddhism',
        'Christianity',
        'Hinduism',
        'Islam',
        'Judaism',
        'Other',
        'Spirituality',
      ],
    },
    {
      title: 'Science & Medicine',
      children: ['Medicine', 'Natural Sciences', 'Social Sciences'],
    },
    {
      title: 'Society & Culture',
      children: [
        'History',
        'Personal Journals',
        'Philosophy',
        'Places & Travel',
      ],
    },
    {
      title: 'Sports & Recreation',
      children: ['Amateur', 'College & High School', 'Outdoor', 'Professional'],
    },
    {
      title: 'Technology',
      children: ['Gadgets', 'Tech News', 'Podcasting', 'Software How-To'],
    },
    {
      title: 'TV & Film',
      children: [],
    },
  ],
  getFeedUrl,
};

function isEmbedPath(path = '') {
  return (
    path &&
    (path.indexOf('/e/') === 0 ||
      path.match(/\/embed$/) ||
      path.match(/\/embed\/episodes\//))
  );
}

function isRWFPath(path = '') {
  return path && Boolean(path.match(/\/call\//));
}

function isPodcastDashboardPath(path = '') {
  return path.indexOf('/dashboard') === 0;
}

function doHideGetAppButton(path = '') {
  const { parseUserAgent, windowUndefined } = serverRenderingUtils;
  if (windowUndefined()) {
    return false;
  }
  const { mobile } = parseUserAgent();
  if (mobile) {
    // episodes pages, as they have a high get the app button
    if (path.indexOf('/rr/') === 0) {
      return true;
    }
    // call join invitations (VOIP)
    if (path.indexOf('/call/') !== -1) {
      return true;
    }
    return false;
  }
  return false;
}

function getBaseUrl() {
  if (process.env.BASE_URL) {
    return process.env.BASE_URL;
  }
  // old way
  return {
    local: `http://localhost:${process.env.PORT || 8012}`,
    development: 'https://v2websitedev2.anchor.fm',
    staging: 'https://anchor.fm',
    production: 'https://anchor.fm',
  }[ENVIRONMENT || 'local'];
}

function getFeedUrl(encodedStationId) {
  return `https://anchor.fm/s/${encodedStationId}/podcast/rss`;
}

function getDateWithoutHours(date) {
  const dateWithoutHours = new Date(date);
  dateWithoutHours.setHours(0);
  dateWithoutHours.setMinutes(0);
  dateWithoutHours.setSeconds(0);
  dateWithoutHours.setMilliseconds(0);
  return dateWithoutHours;
}

function getBlobUrlCreator() {
  if (serverRenderingUtils.windowUndefined()) {
    return null;
  }
  const blob = window.URL || window.webkitURL;
  return blob || null;
}

// https://s3-us-west-2.amazonaws.com/anchor-generated-image-bank/production/podcast_uploaded400/1890044/1890044-1559660713392-d254bee27e32.jpg
// https://d3t3ozftmdmh3i.cloudfront.net/production/podcast_uploaded400/1890044/1890044-1559660713392-d254bee27e32.jpg
function replaceGeneratedImageBankUrlWithCdn(url) {
  return (
    url &&
    url.replace(
      's3-us-west-2.amazonaws.com/anchor-generated-image-bank',
      'd3t3ozftmdmh3i.cloudfront.net'
    )
  );
}

function getPodcastImage({ podcastMetadata = {}, creator = {} }) {
  const podcastImage =
    podcastMetadata.podcastImage ||
    podcastMetadata.podcastImage400 ||
    creator.imageUrl;

  if (podcastImage) {
    return replaceGeneratedImageBankUrlWithCdn(podcastImage);
  }

  return DEFAULT_PODCAST_IMAGE;
}

function getEpisodeImage({ episode = {}, podcastMetadata = {}, creator = {} }) {
  const episodeImage =
    episode.episodeImage || podcastMetadata.podcastImage || creator.imageUrl;

  if (episodeImage) {
    return replaceGeneratedImageBankUrlWithCdn(episodeImage);
  }

  return DEFAULT_PODCAST_IMAGE;
}

function appStoreLink(campaign = 'WebsiteTracking') {
  return `https://itunes.apple.com/app/apple-store/id1056182234?pt=118017867&ct=${campaign}&mt=8`;
}

function playStoreLink(config = {}) {
  const sourceAndCampaign = config.campaign
    ? encodeURIComponent(config.campaign)
    : encodeURIComponent('Anchor Home');
  let referrerParam = `utm_source=${sourceAndCampaign}&utm_medium=cpc&utm_campaign=${sourceAndCampaign}&anid=admob`;
  if (config.callJoinCode) {
    referrerParam = `${referrerParam}&call_join_code=${config.callJoinCode}`;
  }
  if (config.referralCode) {
    referrerParam = `${referrerParam}&referral_code=${config.referralCode}`;
  }
  return `https://play.google.com/store/apps/details?id=fm.anchor.android&referrer=${encodeURIComponent(
    referrerParam
  )}`;
}
